import { Link } from 'react-router-dom';
import { ScrollRevealWrapper } from '../../../components/feature/ScrollRevealWrapper';

const experiencias = [
  {
    icon: 'ri-flashlight-line',
    titulo: 'Ancoragem de Poder',
    subtitulo: 'Estado de Pico Instantâneo',
    descricao: 'Ative seu estado de alta performance em segundos. Técnica para acessar recursos internos ilimitados de confiança e presença.',
    duracao: '45 min',
    nivel: 'Avançado',
    resultado: 'Confiança Sob Demanda',
    link: '/exercicio-gratis/ancoragem-emocional',
  },
  {
    icon: 'ri-brain-line',
    titulo: 'Reprogramação Neural',
    subtitulo: 'Técnica Swish Avançada',
    descricao: 'Elimine padrões limitantes e instale novos comportamentos de sucesso. Reprogramação mental em nível subconsciente profundo.',
    duracao: '60 min',
    nivel: 'Expert',
    resultado: 'Mudança Permanente',
    link: '/exercicio-gratis/tecnica-swish-pnl',
  },
  {
    icon: 'ri-focus-3-line',
    titulo: 'Ressignificação',
    subtitulo: 'Reframing de Crenças',
    descricao: 'Transforme experiências negativas em recursos poderosos. Mude o significado de eventos e instale novas perspectivas.',
    duracao: '50 min',
    nivel: 'Intermediário',
    resultado: 'Nova Perspectiva',
    link: '/exercicio-gratis/ressignificacao-reframing-pnl',
  },
  {
    icon: 'ri-fire-line',
    titulo: 'Encantations',
    subtitulo: 'Método Tony Robbins',
    descricao: 'Afirmações com movimento e emoção intensa. Reprograme seu sistema nervoso através de fisiologia, linguagem e estado.',
    duracao: '30 min',
    nivel: 'Todos os Níveis',
    resultado: 'Estado Energético Elevado',
    link: '/exercicio-gratis/encantations-tony-robbins',
  },
  {
    icon: 'ri-time-line',
    titulo: 'Linha do Tempo',
    subtitulo: 'Reprogramação Temporal',
    descricao: 'Libere traumas do passado e programe o futuro desejado. Reorganize sua linha do tempo para clareza e propósito.',
    duracao: '70 min',
    nivel: 'Avançado',
    resultado: 'Liberdade Emocional',
    link: '/exercicio-gratis/linha-tempo-pnl',
  },
  {
    icon: 'ri-gem-line',
    titulo: 'Submodalidades',
    subtitulo: 'Controle da Experiência',
    descricao: 'Domine como seu cérebro codifica experiências. Amplifique recursos positivos e reduza experiências limitantes.',
    duracao: '55 min',
    nivel: 'Expert',
    resultado: 'Maestria Mental',
    link: '/exercicio-gratis/submodalidades-pnl',
  },
];

export default function ExperienciasComplementares() {
  return (
    <section className="py-24 bg-[#0a0a0a] relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,rgba(201,164,64,0.04),transparent_55%)]"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <ScrollRevealWrapper animation="fade-up">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-4 mb-6">
              <div className="h-px w-10 bg-gradient-to-r from-transparent to-gold-500/60"></div>
              <span className="text-gold-400 text-xs font-semibold tracking-[0.35em] uppercase font-['Montserrat']">
                Arsenal Completo
              </span>
              <div className="h-px w-10 bg-gradient-to-l from-transparent to-gold-500/60"></div>
            </div>
            <h2 className="font-display text-5xl md:text-6xl font-bold text-white mb-5 leading-tight">
              Técnicas de <span className="text-gold-400">Performance Mental</span>
            </h2>
            <p className="text-white/50 text-lg max-w-2xl mx-auto leading-relaxed font-['Montserrat'] font-light">
              Protocolos avançados de PNL clínica para reprogramação profunda, usados por profissionais e líderes de alta performance
            </p>
          </div>
        </ScrollRevealWrapper>

        {/* Stats */}
        <ScrollRevealWrapper animation="fade-up" delay={0.1}>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-14 max-w-3xl mx-auto">
            {[
              { numero: '6', label: 'Técnicas avançadas' },
              { numero: '10.247', label: 'Mentes reprogramadas' },
              { numero: '95%', label: 'Taxa de satisfação' },
              { numero: '4.9/5', label: 'Avaliação' },
            ].map((stat, i) => (
              <div key={i} className="bg-[#111111] border border-gold-500/10 p-4 rounded-xl text-center">
                <div className="font-display text-2xl font-bold text-gold-400 mb-1">{stat.numero}</div>
                <div className="text-xs text-white/30 font-['Montserrat'] tracking-wide uppercase">{stat.label}</div>
              </div>
            ))}
          </div>
        </ScrollRevealWrapper>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mb-14">
          {experiencias.map((exp, i) => (
            <ScrollRevealWrapper key={i} animation="fade-up" delay={0.07 * i}>
              <Link
                to={exp.link}
                className="group relative bg-[#111111] border border-gold-500/10 rounded-2xl overflow-hidden hover:border-gold-500/40 transition-all duration-400 hover:-translate-y-1 block"
              >
                {/* Top line */}
                <div className="h-px w-full bg-gradient-to-r from-gold-500/0 via-gold-500/40 to-gold-500/0 group-hover:via-gold-500/70 transition-all duration-400"></div>

                <div className="p-7">
                  <div className="flex items-start justify-between mb-5">
                    <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gold-500/10 border border-gold-500/15 group-hover:bg-gold-500 group-hover:border-gold-400 transition-all duration-300">
                      <i className={`${exp.icon} text-xl text-gold-400 group-hover:text-[#0a0a0a] transition-colors`}></i>
                    </div>
                    <div className="text-right">
                      <div className="text-white/25 text-xs font-['Montserrat']">{exp.nivel}</div>
                      <div className="flex items-center gap-1 text-white/25 text-xs font-['Montserrat'] justify-end mt-0.5">
                        <i className="ri-time-line text-xs"></i>
                        {exp.duracao}
                      </div>
                    </div>
                  </div>

                  <h3 className="font-display text-lg font-bold text-white mb-1 group-hover:text-gold-400 transition-colors">{exp.titulo}</h3>
                  <p className="text-gold-400 text-xs font-semibold mb-3 font-['Montserrat']">{exp.subtitulo}</p>
                  <p className="text-white/40 text-sm leading-relaxed mb-5 font-['Montserrat']">{exp.descricao}</p>

                  <div className="flex items-center justify-between pt-4 border-t border-gold-500/8">
                    <div className="flex items-center gap-2">
                      <i className="ri-checkbox-circle-fill text-gold-400 text-sm"></i>
                      <span className="text-white/50 text-xs font-['Montserrat']">{exp.resultado}</span>
                    </div>
                    <div className="flex items-center gap-1 text-gold-400/60 text-xs font-['Montserrat'] group-hover:translate-x-0.5 transition-transform">
                      Acessar <i className="ri-arrow-right-line text-xs"></i>
                    </div>
                  </div>
                </div>
              </Link>
            </ScrollRevealWrapper>
          ))}
        </div>

        {/* CTA Final */}
        <ScrollRevealWrapper animation="fade-up" delay={0.4}>
          <div className="text-center bg-gradient-to-r from-[#1a1400] to-[#0f0c00] border border-gold-500/20 rounded-2xl p-10">
            <h3 className="font-display text-3xl font-bold text-white mb-3">
              Pronta para dominar <span className="text-gold-400">sua mente?</span>
            </h3>
            <p className="text-white/45 text-sm mb-7 font-['Montserrat']">
              Acesse o protocolo completo de técnicas de PNL e reprogramação mental.
            </p>
            <Link
              to="/planos"
              className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-gold-500 to-gold-700 text-[#0a0a0a] font-bold rounded-full hover:from-gold-600 hover:to-gold-800 transition-all whitespace-nowrap font-['Montserrat'] text-sm tracking-wide"
            >
              Acessar Arsenal Completo
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </ScrollRevealWrapper>
      </div>
    </section>
  );
}
